import { render, staticRenderFns } from "./companyProfile.vue?vue&type=template&id=0bd14cb4&scoped=true&"
import script from "./companyProfile.vue?vue&type=script&lang=js&"
export * from "./companyProfile.vue?vue&type=script&lang=js&"
import style0 from "./companyProfile.vue?vue&type=style&index=0&id=0bd14cb4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd14cb4",
  null
  
)

export default component.exports